// Content + asset imports for the Editorial landing page.
// Repeated card sections (deals, guides, app screens, press) are data-driven.

import logoWhite from 'assets/landing/lyfe-logo-white.png';

import appDiscover from 'assets/landing/app-discover.png';
import appVenue from 'assets/landing/app-venue.png';
import appShare from 'assets/landing/app-share.png';

import heroCocktail from 'assets/landing/venues/hero-cocktail.jpg';
import bodega from 'assets/landing/venues/bodega.jpg';
import deadFlamingo from 'assets/landing/venues/dead-flamingo.jpg';
import astraRooftop from 'assets/landing/venues/astra-rooftop.jpg';
import lucky1800 from 'assets/landing/venues/1800-lucky.jpg';
import puttery from 'assets/landing/venues/puttery.jpg';
import tokyoSushi from 'assets/landing/venues/tokyo-sushi.avif';

import coverBrickell from 'assets/landing/guides/cover-brickell.jpg';
import coverCoralGables from 'assets/landing/guides/cover-coral-gables.jpg';
import coverCollege from 'assets/landing/guides/cover-college.jpg';

import pressOceanDrive from 'assets/landing/press/ocean-drive.png';
import pressTimeOut from 'assets/landing/press/time-out.png';
import pressModernLuxury from 'assets/landing/press/modern-luxury.png';
import pressMedium from 'assets/landing/press/medium.png';

export { logoWhite, heroCocktail };

export const APP_STORE_URL = 'https://apps.apple.com/us/app/lyfe-social/id1617513052';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ai.rekall.lyfesocial&pli=1';
export const PARTNERS_EMAIL = 'partnerships@lyfe-social.com';

export const navLinks = [
  { label: 'How it works', href: '#how' },
  { label: 'Tonight', href: '#tonight' },
  { label: 'City guides', href: '#guides' },
];

export const categories = ['Bars', 'Restaurants', 'Clubs', 'Concerts & Live events'];

export const howSteps = [
  {
    n: '01',
    title: "Tell Lyfe you're out",
    body: 'Open the app the moment you head out. No planning, no reservations — just where you are, right now.',
  },
  {
    n: '02',
    title: "See what's live nearby",
    body: 'Real-time deals, crowds and vibes from bars, clubs, live events and restaurants around you.',
  },
  {
    n: '03',
    title: 'Check in & keep moving',
    body: 'Claim the deal, check in, and let Lyfe line up the next stop. The night keeps its momentum.',
  },
];

export const appScreens = [
  { img: appDiscover, alt: 'Lyfe map of live venues', n: '01', caption: "See what's live near you", featured: false },
  { img: appVenue, alt: 'Lyfe venue detail with a free drink promo', n: '02', caption: 'Claim your free drink', featured: true },
  { img: appShare, alt: 'Lyfe share-with-friends to claim screen', n: '03', caption: 'Share it, pull up the crew', featured: false },
];

export const deals = [
  { img: bodega, alt: 'Bodega Taqueria y Tequila interior', tag: 'Bar · Tequila', place: 'Bodega Taqueria y Tequila · Coconut Grove', title: 'Extended Happy Hour', when: 'Mon–Fri · 4–9 PM' },
  { img: deadFlamingo, alt: 'The Dead Flamingo bar', tag: 'Bar', place: 'The Dead Flamingo · Little River', title: 'Free Shot', when: 'Tue & Thu · from 9 PM' },
  { img: astraRooftop, alt: 'Astra Rooftop bar', tag: 'Rooftop', place: 'Astra Rooftop · Brickell', title: 'Free Mimosa', when: 'Sundays · from 12 PM' },
  { img: lucky1800, alt: '1-800-Lucky crowd', tag: 'Live event', place: '1-800-Lucky · Wynwood', title: 'Taco Tuesdays', when: 'Tuesdays · from 12 PM' },
  { img: puttery, alt: 'Puttery', tag: 'Bar · Golf', place: 'Puttery · Downtown', title: 'Golf & Drinks', when: 'Tue–Fri · from 3 PM' },
  { img: tokyoSushi, alt: 'Tokyo Sushi Speakeasy cocktails', tag: 'Speakeasy', place: 'Tokyo Sushi Speakeasy · South Beach', title: 'Free Sake!', when: 'Mon · Wed · Thu · from 5 PM' },
];

export const guides = [
  { img: coverBrickell, href: '/guides/brickell', spots: '11 spots', title: 'Brickell Hit List', body: 'Rooftops, cocktail dens & late-night eats in the high-rise heart of the city.' },
  { img: coverCoralGables, href: '/guides/coral-gables', spots: '13 spots', title: 'Coral Gables Hit List', body: 'Date-night dinners and grown-up bars under the banyans.' },
  { img: coverCollege, href: '/guides/college', spots: '9 spots', title: 'College Hot Spots', body: 'Cheap shots, big nights — where the students actually go.' },
];

export const pressLogos = [
  { img: pressOceanDrive, alt: 'Modern Luxury — Ocean Drive', height: 56 },
  { img: pressTimeOut, alt: 'Time Out', height: 54 },
  { img: pressModernLuxury, alt: 'Modern Luxury', height: 30 },
  { img: pressMedium, alt: 'Medium', height: 26 },
];

export const venueSteps = [
  { n: '1', title: 'Apply', body: 'Tell us about your venue and the promo you want to run.', accent: 'blue' },
  { n: '2', title: 'Get set up', body: 'We help you shape an offer that actually drives traffic, then list you.', accent: 'blue' },
  { n: '3', title: 'Go live tonight', body: 'Your deal appears on the live map for every Lyfe user nearby.', accent: 'orange' },
];

export const footerColumns = [
  {
    heading: 'Explore',
    links: [
      { label: 'How it works', href: '#how' },
      { label: "Tonight's deals", href: '#tonight' },
      { label: 'City guides', href: '#guides' },
      { label: 'For venues', href: '#venues' },
    ],
  },
  {
    heading: 'Neighborhoods',
    links: [
      { label: 'Wynwood', href: '#tonight' },
      { label: 'Brickell', href: '#tonight' },
      { label: 'South Beach', href: '#tonight' },
      { label: 'Coral Gables', href: '#tonight' },
    ],
  },
  {
    heading: 'Get the app',
    links: [
      { label: 'iOS · App Store', href: APP_STORE_URL, external: true },
      { label: 'Android · Google Play', href: PLAY_STORE_URL, external: true },
    ],
  },
];
